import { openBlock as t, createElementBlock as h, createStaticVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, e = /* @__PURE__ */ l('<path fill="#FCFCFC" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#FFDA44" d="M23.397 13.972a3.397 3.397 0 0 0-6.794 0H9.13c0 1.847 1.61 3.345 3.456 3.345h-.11a3.344 3.344 0 0 0 3.343 3.344 3.344 3.344 0 0 0 2.726 3.285l-.008.02h2.927l-.01-.02a3.344 3.344 0 0 0 2.726-3.285 3.345 3.345 0 0 0 3.345-3.344h-.111c1.846 0 3.455-1.498 3.455-3.345h-7.472Z"></path><path fill="#FFDA44" d="M18.507 23.62 16.4 28.373a9.537 9.537 0 0 0 3.6.703 9.534 9.534 0 0 0 3.598-.703l-2.106-4.755h-2.986Z"></path><path fill="#F0F0F0" d="M15.652 15.643v5.85c0 3.329 4.348 4.348 4.348 4.348s4.348-1.02 4.348-4.347v-5.851h-8.696Z"></path><path fill="#338AF3" d="m4.85 20.14 2.35 6.579 2.327-6.577h1.776l-3.392 8.695H6.49l-3.417-8.695H4.85Zm27.324 8.696v-8.695h1.69v8.695h-1.69Z"></path><path fill="#D80027" d="M17.391 17.532v7.09c.598.44 1.241.743 1.74.936v-8.026h-1.74Zm5.218 0v7.09a7.613 7.613 0 0 1-1.74.936v-8.026h1.74Z"></path><path fill="#0052B4" d="M15.652 15.643h8.696v2.759h-8.696v-2.76Z"></path>', 7), c = [
  e
];
function o(p, i) {
  return t(), h("svg", a, [...c]);
}
const s = { render: o };
export {
  s as default,
  o as render
};
